<template>
  <GridBase news-faq>
    <h2>
      <p v-if="kr">새로운 소식과 <br>정확한 정보</p>
      <p v-else>FURTHER UPDATES <br class="hidden-sm-down">AND ACCURATE <br>INFORMATION</p>
    </h2>
    <Wrapper>
      <TabList :obj="{news: 'News',faq: 'FAQ'}" v-model="category" @change="refresh" class="q"/>
    </Wrapper>
    <CardHolder>
      <ArchiveCard v-for="item in cardList" card-type="article-n" :key="item.sq" :item="item" data-fill="6,3,2,2" @click="$router.push(`/archive/news-faq/${item.seq}?category=${item.category}`)"/>
    </CardHolder>
    <More v-if="false"/>
  </GridBase>
</template>
<script>
import _ from 'lodash';
import GridBase from '@/views/components/GridBase';
import TabList from '@/views/components/TabList';
import Wrapper from '@/views/components/Wrapper';
import CardHolder from '@/views/components/CardHolder';
import ArchiveCard from '@/views/components/ArchiveCard';
import More from '@/views/components/More';
import responsive from '@/utils/responsive';
// import kr from '@/data/archive/news-faq';
// import en from '@/data/archive/news-faq.en';

// const newsData = { kr, en };

export default {
  name: 'data-tech',
  components: { More, ArchiveCard, CardHolder, Wrapper, TabList, GridBase },
  data() {
    return {
      featuredFill: [
        '6,3,3,3',
        '6,3,3,3',
        '6,6,6,3',
      ],
      category: 'news',
      cardList: [],
    };
  },
  watch: {
    '$route': 'routed',
  },
  computed: {
  },
  methods: {
    tagClick(tag) {
      console.log(tag);
    },
    routed() {
      this.oax.get(`/nosso/datacenter/${this.category}/list`, { langType: this.langType })
        .then(({ data }) => { 
          _.forEach( data.data, row => { 
            row.category = this.category;
            if (this.category === 'news') {
              row.type = row.thumbnailPath ? 'img' : 'text';
            } else {
              row.type = 'faq';
            }
          });
          this.cardList = data.data;
          responsive.resized();
        })
        .catch(this.handler());
    },
    refresh() {
      this.$router.push({query: { category: this.category }});
    },
  },
  mounted() {
    this.category = ( this.$route.query && this.$route.query.category ) || 'news';
    this.routed();
  },
}
</script>

<style lang="less">
@import "~@/less/proj";
[news-faq] { .pb(100);
  h2 { .pt(60); .ml(20); .fs(48,64,-2); color: #fff;
    .en & { .fs(54,60,0); .semi-bold; }
  }
  .skirt { .abs; .wf; .bgc(#191919); .h(170); }
  [tab-list] { .mt(80); }
  [drop-select] { .block; .mt(20); }
  [tag-list] { .hide; }

  [card-holder] { .mt(40); }
}

@media (min-width: @screen-md-min) {
  [news-faq] { .pb(120);
    h2 { .ml(50);}
    .skirt { .h(218); }
    [tab-list] { .mt(100); .w(222); .mh-c;}

    .featured-list {
      [archive-card]:nth-child(1), [archive-card]:nth-child(2) {
        [archive-card-content] { .vw-h(350,768);
          .content-inner {
            .title { .vw-fs(24, 1.5, 768); .vw-max-h(72, 768); }
          }
        }
      }
    }
  }
}

@media (min-width: @screen-lg-min) {
  [news-faq] { .pb(160);
    h2 { .pt(90); .ml(25%); .pl(20); .tl; .fs(80,110,-2);
      .en & { .fs(76,80,0); }
    }
    .skirt { .vw-h(196); }

    [drop-select] { .hide; }
    [tag-list] { .block; .mt(40); }

    .featured-list {
      [archive-card]:nth-child(1), [archive-card]:nth-child(2) {
        [archive-card-content] { .vw-h(350,768);
          .content-inner {
            .title { .fs(34, 1.47); .max-h(100); }
            .txt { .fs(16, 1.75); .ls(-0.5); }
          }
        }
      }
    }
  }
}

@media (min-width: @screen-xxl-min) {
  [news-faq] { .pb(264);
    h2 { .pt(150); .pl(40); .fs(100,125,-2.5);
      .en & { .fs(120,125,0); }
    }
    .skirt { .h(418); }

    [tab-list] { .mt(120); .mh(0); }
    [drop-select] { .hide; }
    [tag-list] { .block; .mt(40); }

    .featured-list {
      [archive-card]:nth-child(1) [archive-card-content] { .h(597); }
      [archive-card]:nth-child(2) [archive-card-content] { .h(368); }
      [archive-card]:nth-child(3) [archive-card-content] { .h(191);
        .title { .fs(24,1.5); .ls(-1); .ellipsis(2); }
      }
    }
  }
}



</style>
